import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createCustomMissingTranslationHandler, createTranslateLoader } from './app.component';
import { CustomHttpErrorInterceptor } from '@balloon-race-fullstack-monorepo/dbr-common';
import '@angular/common/locales/global/de-CH';
import { ApiModule } from '@balloon-race-fullstack-monorepo/dbr-rest-api';
import { ENVIRONMENT } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([CustomHttpErrorInterceptor])),
    importProvidersFrom(
      TranslateModule.forRoot({
        missingTranslationHandler: {
          provide: MissingTranslationHandler,
          useFactory: createCustomMissingTranslationHandler,
        },
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      }),
    ),
    {
      provide: LOCALE_ID,
      useValue: 'de-CH',
    },
    importProvidersFrom(ApiModule.forRoot({ rootUrl: ENVIRONMENT.API.BASE_URL }))
  ],
};
